import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class AsszociaciosKerdesDto extends IdentifiableDto {
	constructor() {
		super();
		this.sorszamTol = null;
        this.sorszamIg = null;
        this.alsorszamTol = null;
        this.alsorszamIg = null;
        this.subsorszamTol = null;
        this.subsorszamIg = null;
        this.csorszam = null;

        this.leiras = null;
        this.leirasPlaintext = null;
        
		this.feladatCsoport = null;
    }

	setup(props) {
		super.setup(props);
        this.sorszamTol = props.sorszamTol;
        this.sorszamIg = props.sorszamIg;
        this.alsorszamTol = props.alsorszamTol;
        this.alsorszamIg = props.alsorszamIg;
        this.subsorszamTol = props.subsorszamTol;
        this.subsorszamIg = props.subsorszamIg;
        this.csorszam = props.csorszam;

        this.leiras = props.leiras;
        this.leirasPlaintext = props.leirasPlaintext;

		this.feladatCsoport = props.feladatCsoport;
		// this.roles = ['Admin'];
		return this;
	}

	getAsString(key) {
		if (key === 'feladatCsoport') {
			return this.feladatCsoport != null ? this.feladatCsoport.name : ''
		}
		return super.getAsString(key);
	}
}

export default AsszociaciosKerdesDto;